import { createFileRoute, notFound } from "@tanstack/react-router"
import LandingPageView from "@/components/landing-page"
import { SALT_BREAD_PAGE } from "@/lib/data/landing/salt-bread"
import { buildLandingHead } from "@/lib/utils/landing-head"

const SUPPORTED_COUNTRY_CODES = new Set(["us"])

export const Route = createFileRoute("/$countryCode/salt-bread")({
  loader: ({ params }) => {
    if (!SUPPORTED_COUNTRY_CODES.has(params.countryCode.toLowerCase())) {
      throw notFound()
    }
    return { countryCode: params.countryCode }
  },
  head: () => buildLandingHead(SALT_BREAD_PAGE),
  component: () => <LandingPageView page={SALT_BREAD_PAGE} />,
})
